<template>
  <div class="second__address" v-if="lang">
    <FormRow inline>
      <FormCol field="custom.customStreet" :readonly="readonly" :flex="2" />
      <FormCol
        field="custom.customHouseNumber"
        :readonly="readonly"
        :flex="1"
        class="forceShow"
      />
    </FormRow>
    <FormRow inline>
      <FormCol field="custom.customCity" :flex="2" :readonly="readonly" />
      <FormCol field="custom.customZip" :flex="1" :readonly="readonly" />
    </FormRow>
  </div>

  <div class="shipping__adress" v-else>
    <FormRow inline>
      <FormCol field="custom.country" width="half"
        ><CountrySelector :lang="lang" :readonly="readonly"
      /></FormCol>
    </FormRow>
    <FormRow inline>
      <FormCol field="custom.street" :readonly="readonly" />
      <FormCol field="custom.street2" :readonly="readonly" />
    </FormRow>
    <FormRow inline>
      <FormCol field="custom.city" :flex="2" :readonly="readonly" />
      <FormCol field="custom.state" :flex="1"
        ><StateSelector :country="form.custom.country" :readonly="readonly"
      /></FormCol>
      <FormCol field="custom.zip" :flex="1" :readonly="readonly" />
    </FormRow>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    lang: {
      type: String,
    },
    readonly: {
      type: Boolean,
    },
  },
  setup() {
    const { form } = usePaymentForm();

    return {
      form,
    };
  },
});
</script>

<style scoped lang="scss">
::v-deep label[for="custom.customStreet"]:after {
  content: "רחוב" !important;
}
::v-deep label[for="custom.customHouseNumber"]:after {
  content: "מספר בית" !important;
}
</style>
